const BIEN = '1'
const SERVICIO = '2'
const ACTIVO_FIJO = '3'

const __dictionary = {
  [BIEN]: {
    id: BIEN,
    nombre: 'BIEN'
  },
  [SERVICIO]: {
    id: SERVICIO,
    nombre: 'SERVICIO'
  },
  [ACTIVO_FIJO]: {
    id: ACTIVO_FIJO,
    nombre: 'ACT. FIJO'
  }
}

const __bsArray = [__dictionary[BIEN], __dictionary[SERVICIO]]

const __array = [__dictionary[BIEN], __dictionary[SERVICIO], __dictionary[ACTIVO_FIJO]]

export default Object.freeze({
  BIEN,
  SERVICIO,
  ACTIVO_FIJO,
  __dictionary,
  __bsArray,
  __array
})
